import useSwr from "@/core/composables/swr/useSwr";
import {notificationSequenceApi} from "@/container";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";

export interface NotificationSequenceTargetingSearchParams {
    from?: string;
}

const useNotificationSequenceTargeting = (sequenceId: number | string, searchParams: NotificationSequenceTargetingSearchParams = {}) => {
    const swrKey = computed(() => {
        return cacheKey(`notification-sequences/${sequenceId}/targeting`, searchParams);
    });

    return useSwr(swrKey, () => {
        return notificationSequenceApi().targeting(sequenceId, searchParams);
    });
};

export default useNotificationSequenceTargeting;
